import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الدائرة على الإنترنت - محيط دائرة نصف قطرها القطر";
const DESCRIPTION =
  "آلة حاسبة الدائرة الشاملة: احسب نصف القطر، القطر، المحيط، المساحة، والزوايا بسهولة. توفر حلولاً رياضية خطوة بخطوة مع تفسيرات واضحة.";
  const KEYWORDS =
  "دائرة ، مساحة ، محيط ، نصف قطر ، قطر ، حاسبة الدائرة ، حساب الدائرة";
const OG_URL = "https://do-calculate.com/calculator/ar/circle-radius";
function CircleRadiusCalculator() {
  const [diameter, setDiameter] = useState("");
  const [circumference, setCircumference] = useState("");
  const [area, setArea] = useState("");
  const [radius, setRadius] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!diameter && !circumference && !area) {
      setError("الرجاء إدخال معلومات صحيحة (القطر أو المحيط أو المساحة)");
      setRadius("");
      return;
    }
    if (diameter) {
      const diameterValue = parseFloat(diameter);
      if (!isNaN(diameterValue) && diameterValue >= 0) {
        setRadius((diameterValue / 2).toFixed(2));
        setError("");
        return;
      }
    }
    if (circumference) {
      const circumferenceValue = parseFloat(circumference);
      if (!isNaN(circumferenceValue) && circumferenceValue >= 0) {
        setRadius((circumferenceValue / (2 * Math.PI)).toFixed(2));
        setError("");
        return;
      }
    }
    if (area) {
      const areaValue = parseFloat(area);
      if (!isNaN(areaValue) && areaValue >= 0) {
        setRadius(Math.sqrt(areaValue / Math.PI).toFixed(2));
        setError("");
        return;
      }
    }
    setError("الرجاء إدخال معلومات صحيحة (القطر أو المحيط أو المساحة)");
    setRadius("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  استخدم هذه الالة الحاسبة للدائرة من اجل حساب و ايجاد محيط
                  الدائره ومساحتها وطول القطر
                </p>
                <h2 style={{ fontSize: "18px" }}>ماهي الدائرة</h2>
                <p>
                  الدائرة عبارة عن سطح تتساوى فيه مسافة جميع نقاط الحافة عن
                  المركز. تستخدم الصيغ التالية في حساب الدائرة. مساحة الدائرة
                  A=pi * r^2 والمحيط يساوي U=2 * pi * r ، حيث pi هو ثابت الدائرة
                  (حوالي 3,14).
                </p>
                <h2 style={{ fontSize: "18px" }}>طريقة حساب نصف قطر الدائرة</h2>
                <p>
                  تقوم هذه الحاسبة ب حساب نصف قطر الدائرة باستخدام المعطيات
                  التالية:
                </p>
                <ol>
                  <li>
                    إذا توفر في المعطيات طول القطر (d)، يمكن حساب النصف عن طريق
                    القانون التالي:
                    <br />
                    نصف القطر = القطر / 2
                  </li>
                  <li>
                    إذا توفرت قيمة محيط الدائرة (C)، يمكن حساب النصف عن طريق
                    القانون التالي:
                    <br />
                    نصف القطر = محيط الدائرة / (2 × π)
                  </li>
                  <li>
                    إذا توفرت قيمة مساحة الدائرة (A)، يمكن حساب النصف عن طريق
                    القانون التالي:
                    <br />
                    نصف القطر = √(مساحة الدائرة / π)
                  </li>
                </ol>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">طول القطر (d)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="إذا توفر القطر"
                        value={diameter}
                        onChange={(e) => setDiameter(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          محيط الدائرة (C)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="إذا توفر المحيط"
                        value={circumference}
                        onChange={(e) => setCircumference(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          مساحة الدائرة (A)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="إذا توفرت المساحة"
                        value={area}
                        onChange={(e) => setArea(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب نصف القطر
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {radius !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              نصف القطر:
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              {radius} سم
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default CircleRadiusCalculator;
